import { createSlice } from '@reduxjs/toolkit';

const hpGasSwitchSlice = createSlice({
  name: 'hpGasSwitch',
  initialState: {},
  reducers: {
    hpGcSpecificLocationSelectMachinesHandler: (state, action) => {
      state[action.payload.location][action.payload.specificLocation][
        action.payload.machine
      ].isSelected = true;
    },
    hpGcHandleSelectIndividualMachine: (state, action) => {
      state[action.payload.location][action.payload.machine].isSelected = true;
    },
    hpGcSpecificLocationUnselectMachinesHandler: (state, action) => {
      state[action.payload.location][action.payload.specificLocation][
        action.payload.machine
      ].isSelected = false;
    },
    hpGcHandleUnSelectIndividualMachine: (state, action) => {
      state[action.payload.location][action.payload.machine].isSelected = false;
    },
  },
});

export default hpGasSwitchSlice;
export const selectHpGasSwitch = (state) => state.hpGasSwitch;
export const {
  hpGcHandleUnSelectIndividualMachine,
  hpGcHandleSelectIndividualMachine,
  hpGcSpecificLocationSelectMachinesHandler,
  hpGcSpecificLocationUnselectMachinesHandler,
} = hpGasSwitchSlice.actions;
